import { put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { TripInformationConstants } from '../store/tripInformation.constants'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { ITripInformationState } from '../store/tripInformation.types'
import { getTripInformationSelector } from '../selectors'
import { setBase } from '../store/tripInformation.actions'

export function* setTripInfoBase() {
  const tripInformation: ITripInformationState = yield select(getTripInformationSelector)
  const { __baseOption } = tripInformation
  try {
    yield put(setBase(__baseOption))
  } catch (e) {
    yield put(throwPcrException(`setTripInfoBase() error: ${e}`))
  }
}

export function* setTripInfoBaseSaga() {
  yield takeLatest([TripInformationConstants.SET_BASE_OPTION], performWithMutexHOG, setTripInfoBase)
}
